import { select } from '@inquirer/prompts'
import { getTargetUrlAndAccessToken } from '../login/accessTokens'
import { doLogin } from '../login/login'
import { testConnection } from '../login/testConnection'
import { SyncTargetManager } from './syncTargetManager'

async function needsValidCredentials(headers: string[], targetUrl?: string) {
  if (!targetUrl) return true
  const targetCredentials = getTargetUrlAndAccessToken(targetUrl)
  if (!targetCredentials) return true
  return await testConnection({
    headers,
    ...targetCredentials
  })
}

export async function getSyncTarget(askForUnixSocket: boolean, headers: string[]) {
  const syncTargetManager = SyncTargetManager.getInstance()
  let target: string | undefined
  if (syncTargetManager.hasSyncTargets()) {
    target = await select({
      message: 'Which instance would you like to sync to?',
      choices: [
        ...syncTargetManager.getSyncTargets().map((target) => {
          return {
            name: target.origin,
            value: target.origin,
          }
        }),
        {
          name: 'Add new target',
          value: undefined,
        },
      ],
    })
  }

  while (await needsValidCredentials(headers, target)) {
    const syncTargetCredentials = await doLogin(askForUnixSocket, headers, 'sync-target', target)
    if (!syncTargetCredentials.error) {
      syncTargetManager.addSyncTarget({ origin: syncTargetCredentials.url })
      target = syncTargetCredentials.url
    }
  }

  return target
}
